import(/* webpackMode: "eager" */ "C:\\Users\\Serhat Altun\\Downloads\\ser\\src\\app\\announcements\\page.tsx");
